import { render, staticRenderFns } from "./KcRuleConfig.vue?vue&type=template&id=397f54e9&scoped=true"
import script from "./KcRuleConfig.vue?vue&type=script&lang=js"
export * from "./KcRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./KcRuleConfig.vue?vue&type=style&index=0&id=397f54e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f54e9",
  null
  
)

export default component.exports